<template lang="pug">
  .presentation
    div(v-if="slides.length")
      .view
        .image: img(:src="slides[currentSlide].image")

      .control.level
        .is-pulled-left
          ui-button(icon="undo" @click="$router.go(-1)") Вернуться к списку
          //- ui-button(icon="view-dashboard" disabled)
          slot(name="controls")
        b-taglist.level-item.no-bottom-offset(v-if="!isLastSlide")
          b-tag.no-bottom-offset Слайд {{currentSlide + 1}} / {{slides.length}}
          //- b-tag.no-bottom-offset Время показа {{currentSlideTime | prettyTimestamp}}
          b-tag.no-bottom-offset Показано слайдов {{lastViewedSlide + 1}} | {{((lastViewedSlide + 1) / slides.length) | percentage}}

        b-field.is-pulled-right(horizontal)
          ui-button.is-large(:disabled="currentSlide === 0" @click="prevSlide" icon="arrow-left")
          ui-button.is-primary.is-large(v-if="!isLastSlide" @click="nextSlide" icon="arrow-right")
          ui-button.is-success.is-large(v-else @click="finish" icon="check") Я ознакомился с материалом
</template>

<script>
import Log from '@/api/Log';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'presentation',

  props: {
    presentation: {
      type: Object,
    },
  },

  data() {
    return {
      currentSlide: 0,
      currentSlideTime: 0,
      lastViewedSlide: 0,
      slideTimerInterval: null,
      finished: false,
    };
  },

  computed: {
    isLastSlide() {
      return this.currentSlide == this.slides.length - 1;
    },
    slides() {
      return this.presentation ? this.presentation.slides : [];
    },
  },

  methods: {
    resetSlideTimer() {
      this.stopSlideTimer();

      this.currentSlideTime = 0;

      this.slideTimerInterval = setInterval(() => {
        this.currentSlideTime++;
      }, 1000);
    },

    stopSlideTimer() {
      if (this.slideTimerInterval) {
        clearInterval(this.slideTimerInterval);
      }
    },

    slideChanged() {
      this.resetSlideTimer();
    },

    prevSlide() {
      this.currentSlide = Math.max(0, this.currentSlide - 1);

      this.slideChanged();
    },

    nextSlide() {
      this.currentSlide = Math.min(this.slides.length - 1, this.currentSlide + 1);

      if (this.currentSlide > this.lastViewedSlide) {
        this.lastViewedSlide = this.currentSlide;

        Log.store('next_slide', this.presentation);
      }

      this.slideChanged();
    },

    finish() {
      this.finished = true;

      this.stopSlideTimer();

      Toast.open({
        message: 'Материал пройден!',
        type: 'is-success',
        // position: 'is-bottom-right',
        duration: 5000,
      });

      Log.store('stop_watching', this.presentation);

      this.$router.push({ name: 'site.lessons' });
    },

    onKeyPressed(e) {
      switch (e.code) {
        case 'ArrowLeft':
          this.prevSlide();

          break;
        case 'ArrowRight':
          this.nextSlide();

          break;
      }
    },
  },

  filters: {
    prettyTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);

      return date.getMinutes() + ':' + date.getSeconds();
    },

    percentage(value) {
      if (value === 0) {
        return '0%';
      }

      return Math.round(value * 100) + '%';
    },
  },

  mounted() {
    this.resetSlideTimer();

    document.addEventListener('keydown', this.onKeyPressed);

    if (this.presentation) {
      Log.store('start_watching', this.presentation);
    }
  },

  beforeDestroy() {
    this.stopSlideTimer();

    document.removeEventListener('keydown', this.onKeyPressed);
  },
};
</script>

<style lang="scss" scoped>
.presentation {
  // width: 600px;
  max-width: 1000px;
}

.no-bottom-offset {
  margin-bottom: 0;
}

// .fit {
//   width: 100%;
//   height: 100%;
// }

.control {
  // width: 800px;
  padding: 10px;
  background-color: #dbdbdb;
}
</style>
